import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map} from 'rxjs/operators';
import {ProductosRespaldos} from '../_models/productos-respaldos';
import {ProductosPeriodosGracias} from '../_models/productos-periodos-gracias';

@Injectable({
  providedIn: 'root'
})
export class ProductosPeriodosGraciasService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosPeriodosGracias';
  constructor(private httClient: HttpClient, private autServicio: AutenticacionService) { }

  getByIdProducto( idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/unica/' + idProducto ).pipe( map( res => res as ProductosPeriodosGracias ) );
  }

  add( data: ProductosPeriodosGracias ) {
    data.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, data ).pipe( map( res => res as ProductosPeriodosGracias ) );
  }
  update( data: ProductosPeriodosGracias ) {
    data.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, data ).pipe( map( res => res as ProductosPeriodosGracias ) );
  }
}
